import type {FieldId, SearchParams, SetFieldValueRequest, UUID} from 'src/typings';
import type {AjaxService} from 'core/data-services/ajax.service';
import {transferify} from 'shared/utils/data-service-utils';

export interface RecordBulkEditParams {
    fieldEditRequests: RecordBulkEditFieldRequest[];
    additionalInvalidatingRecords?: UUID[];
}

export interface RecordBulkEditFieldRequest {
    id: FieldId;
    setFieldValueRequest: SetFieldValueRequest;
}

export class RecordBulkEditDataService {
    public static serviceName = 'recordBulkEditDataService';

    private static readonly ROUTE = 'records/fields/bulkedit/simplev1';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    public async bulkEditRecords<PARAMS extends SearchParams = SearchParams>(params: PARAMS, bulkEditParams: RecordBulkEditParams): Promise<UUID[]> {
        return this.ajaxService
            .createRequest(RecordBulkEditDataService.ROUTE)
            .post({
                fieldEditRequests: bulkEditParams.fieldEditRequests,
                additionalInvalidatingRecords: bulkEditParams.additionalInvalidatingRecords
            }, transferify(params));
    }
}
